var FaqDataTestId = /* @__PURE__ */ ((FaqDataTestId2) => {
  FaqDataTestId2["FAQ_PROFESSIONAL_TAB_TRIGGER"] = "faq--professional-tab-trigger";
  FaqDataTestId2["FAQ_PATIENT_TAB_TRIGGER"] = "faq--patient-tab-trigger";
  FaqDataTestId2["FAQ_PATIENT_WANT_TO_SCHEDULE_CARD"] = "faq--patient-want-to-schedule-card";
  FaqDataTestId2["FAQ_PATIENT_RESCHEDULE_CANCEL_APPOINTMENT_CARD"] = "faq--patient-reschedule-cancel-appointment-card";
  FaqDataTestId2["FAQ_SUPPORT_PROFESSIONALS_CARD"] = "faq--support-professionals-card";
  FaqDataTestId2["FAQ_PROFESSIONAL_CTA_CARD"] = "faq--professional-cta-card";
  FaqDataTestId2["FAQ_FIND_BRANCH_BUTTON"] = "faq--find-branch-button";
  FaqDataTestId2["FAQ_EMAIL_SAC_BUTTON"] = "faq--email-sac-button";
  FaqDataTestId2["FAQ_ASSISTED_SHOPPING_BUTTON"] = "faq--assisted-shopping-button";
  FaqDataTestId2["FAQ_PROFESSIONAL_BE_OUR_PARTNER_BUTTON"] = "faq--professional-be-our-partner-button";
  FaqDataTestId2["FAQ_PROFESSIONAL_ENTER_SYSTEM_BUTTON"] = "faq--professional-enter-system-button";
  FaqDataTestId2["FAQ_PATIENT_CTA_SCHEDULE_BUTTON"] = "faq--patient-cta-schedule-button";
  FaqDataTestId2["FAQ_SUPPORT_PROFESSIONALS_WHATSAPP_SAC"] = "faq--support-professionals-whatsapp-sac";
  return FaqDataTestId2;
})(FaqDataTestId || {});
export {
  FaqDataTestId
};
